// FIN-11960 — resolve a triggered-rule grouping key (e.g. "sender_hashcode")
// to its human-readable label using the SAME query-builder field metadata the
// Run Instance / Rule configuration screen uses: state.amlsCommon.queryFields
// .data.fields, where fields[...][key].label is e.g. "Sender Identifier". This
// keeps the Score Explainability "Group By" labels in lock-step with the config
// UI instead of a hard-coded map.
//
// formatQueryFields (trmUtil.js) NESTS that metadata by input type —
//   { transaction: { name: { label } }, activity: { name: { label } } }
// — NOT a flat { key: { label } } map (FIN-11960 re-opened: the flat-only
// lookup never matched the nested shape, so the column + dropdown kept rendering
// the raw key). Resolve against either shape: a direct flat hit first
// (back-compat), then the transaction / activity sub-maps. Falls back to the raw
// key when the metadata has no entry (or has not loaded yet) so nothing breaks.
export const groupingKeyDisplayName = (key, fieldsMetaData) => {
  if (!key || !fieldsMetaData) return key;
  const flat = fieldsMetaData[key]?.label;
  if (flat) return flat;
  const nested =
    fieldsMetaData.transaction?.[key]?.label ||
    fieldsMetaData.activity?.[key]?.label;
  return nested || key;
};
